const {
    userAgent,
    isTablet,
    isMobile,
    isIOS,
    isAndroid,
    isIframe,
    isWebview,
} = require('./src/deviceInfo');
const {
    isSafari,
    isFirefox,
    isChrome,
    isEdge,
} = require('./src/browserDetect');

module.exports = {
    userAgent,
    isTablet,
    isMobile,
    isIOS,
    isAndroid,
    isIframe,
    isWebview,
    isSafari,
    isFirefox,
    isChrome,
    isEdge,
};
